<template>
  <div class="b-crop-modal">
    <div class="b-crop">
      <slot name="text"></slot>
      <div class="b-cropper">
        <vue-cropper
          ref="cropper"
          :src="imgSrc"
          :ready="readyFunction"
          :cropBoxMovable="false"
          :toggleDragModeOnDblclick="false"
          :zoomOnWheel="false"
          :zoomOnTouch="false"
          :cropmove="cropmove"
          :viewMode="0"
          :minContainerWidth="containerWidth"
          :minContainerHeight="containerHeight"
        />
        <div class="slidecontainer">
          <input
            type="range"
            min="0"
            max="2"
            :value="ZoomLevel"
            class="slider"
            id="myRange"
            step="0.001"
            v-on:input="ZoomInput"
          />
        </div>
        <div class="b-cropper-action">
          <div>
            <img src="../assets/rotate-left.svg" class="rotate-buttons" @click="rotate(-90);" />
          </div>
          <div class="b-crop-spacer"></div>
          <div>
            <img src="../assets/rotate-right.svg" class="rotate-buttons" @click="rotate(90);" />
          </div>
        </div>
      </div>
      <div class="b-croppie-button">
        <button @click="reset();" type="button" class="button-primary button-primary-reset">Reset</button>
        <button @click="crop();" type="button" class="button-primary">Crop</button>
      </div>
    </div>
  </div>
</template>
<script>
    import VueCropper from "vue-cropperjs";
    import 'cropperjs/dist/cropper.css';

    export default {
        props:{
            containerHeight: {
                type: Number,
                default: 272
            },
            containerWidth: {
                type: Number,
                default: 480
            },
            containerHeightMobile: {
                type: Number,
                default: 180
            },
            containerWidthMobile:{
                type: Number,
                default: 324
            }
        },
        components: {
            VueCropper,
        },
        data(){
            return {
                ZoomLevel: 0.5,
                imgSrc: null
            }
        },
        methods: {
            ZoomInput(evt){
                var zoomValue = parseFloat(evt.target.value);
                this.$refs.cropper.zoomTo(zoomValue.toFixed(4));
            },
            reset(){
                this.readyFunction();
            },
            crop() {
                this.$emit('crop', this.$refs.cropper.getCroppedCanvas());
            },
            rotate(deg) {
                if(this.$listeners && this.$listeners.rotate)
                    this.$emit('rotate', this.$refs.cropper, deg);
                else {
                    const imgData = this.$refs.cropper.getImageData();
                    let contData = this.$refs.cropper.getContainerData();
                    this.$refs.cropper.rotate(deg);
                    let ContainerHeight = this.getContainerHeight();
                    let ContainerWidth = this.getContainerWidth();
                    let Height = (ContainerWidth * imgData.naturalHeight) / imgData.naturalWidth;
                    if (imgData.rotate == 90 || imgData.rotate == 270 || imgData.rotate == -90 || imgData.rotate == -270)
                        Height = (ContainerWidth * imgData.naturalWidth) / imgData.naturalHeight;

                    this.$refs.cropper.setCanvasData({top: 0, left: 0, height: ContainerHeight});
                    this.$refs.cropper.setCropBoxData({
                        top: 5,
                        left: 5,
                        height: ContainerHeight - 2,
                        width: ContainerWidth - 6
                    });
                    let canvasData = this.$refs.cropper.getCanvasData();
                    this.ZoomLevel = canvasData.width / canvasData.naturalWidth;
                }
            },

            updateFileName(field, val) {
                field.file = val ? { name: "Already uploaded" } : null;
            },
            updateFile(event){
                this.imgSrc = event;
                this.$refs.cropper.replace(event);
                let contData = this.$refs.cropper.getContainerData();
                // let height = contData.height || 272;
                // let width = contData.width || 480
                // console.log({height, width})
                // this.$refs.cropper.setCanvasData({height, width});
            },

            cropmove(e) {
                if(this.$listeners && this.$listeners.readyFunction)
                    this.$emit('cropmove', this.$refs.cropper);
                else {
                    var canvasData = this.$refs.cropper.getCanvasData();
                    var cropBoxData = this.$refs.cropper.getCropBoxData();

                    if (window.innerWidth > 767 && cropBoxData.top + cropBoxData.height > 281) {
                        this.$refs.cropper.setCropBoxData({
                            top: cropBoxData.top,
                            left: cropBoxData.left,
                            height: 279 - cropBoxData.top
                        });
                        e.preventDefault();
                    } else if (window.innerWidth <= 767 && cropBoxData.top + cropBoxData.height > 184) {
                        this.$refs.cropper.setCropBoxData({
                            top: cropBoxData.top,
                            left: cropBoxData.left,
                            height: 184 - cropBoxData.top
                        });
                        e.preventDefault();
                    }
                }
            },
            readyFunction(){
                if(this.$listeners && this.$listeners.readyFunction)
                    this.$emit('readyFunction', this.$refs.cropper);
                else {
                    const imgData = this.$refs.cropper.getImageData();
                    let contData = this.$refs.cropper.getContainerData();
                    let ContainerHeight = this.getContainerHeight();
                    let ContainerWidth = this.getContainerWidth();
                    let Height = (ContainerWidth * imgData.naturalHeight) / imgData.naturalWidth;
                    this.$refs.cropper.setCanvasData({top: 0, left: 0, height: ContainerHeight});
                    this.$refs.cropper.setCropBoxData({
                        top: 5,
                        left: 5,
                        height: ContainerHeight - 2,
                        width: ContainerWidth - 6
                    });

                    let canvasData = this.$refs.cropper.getCanvasData();
                    this.ZoomLevel = canvasData.width / canvasData.naturalWidth;
                    this.$emit('readyFunctionComplete');
                }
            },

            getContainerHeight(){
                let contData = this.$refs.cropper.getContainerData();
                return window.innerWidth>767?(contData.height > this.containerHeight ? this.containerHeight : contData.height):(contData.height > this.containerHeightMobile ? this.containerHeightMobile : contData.height);
            },

            getContainerWidth(){
                let contData = this.$refs.cropper.getContainerData();
                return window.innerWidth>767?(contData.width > this.containerWidth ? this.containerWidth : contData.width):(contData.width > this.containerWidthMobile ? this.containerWidthMobile : contData.width);
            }
        }
    }
</script>
<style>
.button-primary-reset {
  margin-right: 24px;
}
.cropper-point {
  height: 10px !important;
  width: 10px !important;
}
.slidecontainer {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  margin-top: 24px;
}
#myRange {
  width: 242px;
}

.b-crop--close {
  position: absolute;
}

.b-crop {
  display: flex;
  height: 100%;
  flex-flow: column;
  padding: 40px;
}

.cropper-container {
  height: 280px !important;
  width: 486px !important;
}
.croppie-container .cr-slider-wrap {
  margin: 20px auto !important;
}

.b-crop-spacer {
  width: 140px;
}

.b-crop-instruction > li + li {
  padding: 13px 0px 0px 0px;
}

.b-croppie-button {
  text-align: center;
  margin-top: 64px;
}

@media screen and (min-width: 767px) {
  .b-cropper {
    height: 301px;
  }
  .b-crop--close {
    top: 37px;
    right: 37px;
  }
}

@media screen and (max-width: 767px) {
  .b-croppie-button {
    text-align: center;
    margin-top: 134px;
  }
  .cropper-container {
    height: 188px !important;
    width: 328px !important;
  }
  .b-crop {
    padding: 16px;
  }
  .b-crop--close {
    top: 16px;
    right: 16px;
  }
  .b-cropper {
    align-self: center;
    height: 171px;
    border-radius: 4px;
    border: solid 1px #e0e0e0;
    background-color: #ffffff;
  }
}
.cropped-image img {
  max-width: 376px;
  border: 2px solid black;
}

.b-cropper-action {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.croppie-container .cr-slider-wrap {
  width: 100px;
}
.b-cropper-action > div {
  margin: 10px;
}

.b-cropper-action i {
  position: relative;
  top: 3px;
  left: -4px;
  color: white;
}

.modal-content-desktop {
  overflow: hidden;
}

.rotate-buttons {
  margin-bottom: 24px;
}

@media screen and (max-width: 767px) {
  .b-cropper-action {
    height: 90px;
  }

  .croppie-container .cr-slider-wrap {
    margin: 15px 40px;
  }

  .b-crop-spacer {
    width: 80px;
  }

  .b-cropper-action > div {
    margin: 10px 5px;
  }
}
</style>